import styled from "styled-components";
import water from '../images/water.jpg';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PrevPool = () => {
  const {t} = useTranslation();
  return (
    <Wrapper>
        <h3>{t('sloganPiscina')}</h3>
        <Link className="link" to='/pool'>{t('leggiAltro')}</Link>
    </Wrapper>
  )
}

export default PrevPool;

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3)), url(${water});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 400px;
    h3 {
        color: white;
        text-shadow: 0px 2px 5px black;
        padding: 0px 15px;
        font-size: 30px;
        text-transform: uppercase;
        margin-bottom: 25px;
        text-align: center;
    }
    .link {
        background-color: white;
        padding: 5px 10px;
        text-align: center;
        text-transform: uppercase;
        color: var(--logo);
        border-radius: 5px;
        border: 1px solid var(--logo);
    }
`